import { Dialog } from "primereact/dialog";
import React, { Component } from "react";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { Button } from "primereact/button";
import { Check } from "lucide-react";
import { PageLayout } from "../../components/ui";
import Loader from "../../components/Loader";
import { KycSubmissionComment } from "../../models/KycSubmission";

interface AddKycCommentProps {
    onHide: () => void;
    comment: KycSubmissionComment;
    onCommentUpdate: (comment: KycSubmissionComment) => void;
}

interface AddKycCommentState {
    comment: KycSubmissionComment;
    isLoading: boolean;
}

export default class AddKycComment extends Component<AddKycCommentProps, AddKycCommentState> {
    validationErrors: Map<string, boolean> = new Map<string, boolean>();
    constructor(props: AddKycCommentProps | Readonly<AddKycCommentProps>) {
        super(props);

        this.state = {
            comment: this.props.comment,
            isLoading: false,
        };
    }

    updateValue = (fieldName: string, value: string) => {
        const kycComment: any = this.state.comment;
        kycComment[fieldName] = value;
        this.setState({ comment: kycComment });
    };

    onSave = () => {
        this.props.onCommentUpdate(this.state.comment);
    };

    render() {
        if (this.state.comment == null) {
            return (
                <>
                    <Loader />;
                </>
            );
        }
        return (
            <Dialog header="KYC Comment" visible={true} style={{ width: "60vw" }} onHide={this.props.onHide}>
                <PageLayout noTitle>
                            <Row className="d-flex justify-content-center">
                                <Col md={6}>
                                    <FormGroup>
                                        <Label>Comment</Label>
                                        <br />
                                        <textarea
                                            rows={4}
                                            cols={50}
                                            value={this.state.comment?.comment}
                                            onChange={(e) => this.updateValue("comment", e.target.value)}
                                        ></textarea>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="flex justify-end px-5 py-4">
                                <Button
                                    label="Save"
                                    icon={<Check size={16} />}
                                    loading={this.state.isLoading}
                                    onClick={() => {
                                        this.onSave();
                                        this.props.onHide();
                                    }}
                                />
                            </div>
                </PageLayout>
            </Dialog>
        );
    }
}
